import React from 'react';
import bemCn from 'bem-cn';
import { SOCIAL_MEDIA } from '../../consts/blog-author.consts';
import './style.scss';

const b = bemCn('sniff-blog-social');

const BlogSocial = ({ blogAuthor }) => {
    return (
        <ul className={b()}>
            {SOCIAL_MEDIA.map((v, i) => {
                if (!blogAuthor[v.url]) {
                    return undefined;
                }

                const link = `${v.url == 'publicEmail' ? 'mailto:' : ''}${blogAuthor[v.url]}`;

                return (
                    <li key={i}>
                        <a href={link} target="_blank" rel="noopener noreferrer">
                            <v.img />
                        </a>
                    </li>
                );
            })}
        </ul>
    );
};

export default BlogSocial;
